import { SvgIcon, SvgIconProps } from '@mui/material';

export const NatureIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_3471_9259"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3471_9259)">
        <path
          d="M5.14258 22V20H11.1426V16H9.14258C7.75924 16 6.58008 15.5125 5.60508 14.5375C4.63008 13.5625 4.14258 12.3833 4.14258 11C4.14258 10 4.41758 9.07917 4.96758 8.2375C5.51758 7.39583 6.25924 6.78333 7.19258 6.4C7.34258 5.15 7.88841 4.10417 8.83008 3.2625C9.77174 2.42083 10.8759 2 12.1426 2C13.4092 2 14.5134 2.42083 15.4551 3.2625C16.3967 4.10417 16.9426 5.15 17.0926 6.4C18.0259 6.78333 18.7676 7.39583 19.3176 8.2375C19.8676 9.07917 20.1426 10 20.1426 11C20.1426 12.3833 19.6551 13.5625 18.6801 14.5375C17.7051 15.5125 16.5259 16 15.1426 16H13.1426V20H19.1426V22H5.14258ZM9.14258 14H15.1426C15.9759 14 16.6842 13.7083 17.2676 13.125C17.8509 12.5417 18.1426 11.8333 18.1426 11C18.1426 10.4 17.9717 9.85 17.6301 9.35C17.2884 8.85 16.8426 8.48333 16.2926 8.25L15.2426 7.8L15.0926 6.65C14.9926 5.9 14.6634 5.27083 14.1051 4.7625C13.5467 4.25417 12.8926 4 12.1426 4C11.3926 4 10.7384 4.25417 10.1801 4.7625C9.62174 5.27083 9.29258 5.9 9.19258 6.65L9.04258 7.8L7.99258 8.25C7.44258 8.48333 6.99674 8.85 6.65508 9.35C6.31341 9.85 6.14258 10.4 6.14258 11C6.14258 11.8333 6.43424 12.5417 7.01758 13.125C7.60091 13.7083 8.30924 14 9.14258 14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  </SvgIcon>
);

NatureIcon.muiName = 'NatureIcon';
